import { render, staticRenderFns } from "./ContractParties.vue?vue&type=template&id=42afd64a&scoped=true&"
import script from "./ContractParties.vue?vue&type=script&lang=js&"
export * from "./ContractParties.vue?vue&type=script&lang=js&"
import style0 from "./ContractParties.vue?vue&type=style&index=0&id=42afd64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afd64a",
  null
  
)

export default component.exports